import { Badge } from '@lib/components'
import { Button } from '@octopus-do/octopus-storybook'
import cx from 'classnames'
import type React from 'react'

import {
  isTeamPlan,
  PLAN_FREE,
  PLAN_PRO,
  PLAN_PRO2,
  PLAN_PRO3,
  PLAN_TEAM,
  PLAN_TEAM3SEATS,
  PLAN_TEAMPERSEAT,
  PLAN_TEAMPERSEAT2,
} from '@/constants/userSubscriptionPlans'
import { planTypes } from './planTypes'
import css from './pricing.module.scss'
import { getButtonStyle, getButtonText, getVariant } from './utils'

type Props = {
  planType: string
  planId: string
  loadingId: string | null
  planIndex: number
  types: string[]
  onSubscribeClick: (planId: string, name: string, variant: string) => void
}

interface FeaturesProps {
  features: string[]
  color: string
}
const Features: React.FC<FeaturesProps> = ({ features, color }) => (
  <ul className={css.features}>
    {features.map((feature, index) => (
      <li key={index} className={cx(css.item, css.defaultText)}>
        <i className="fa fa-solid fa-check-circle" style={{ color }} />
        <span>{feature}</span>
      </li>
    ))}
  </ul>
)

export const Plan: React.FC<Props> = ({
  planType,
  planId,
  loadingId,
  planIndex,
  types,
  onSubscribeClick,
}) => {
  const availablePlans = [
    PLAN_FREE,
    [PLAN_PRO, PLAN_PRO2].includes(planId) ? planId : PLAN_PRO3,
    [PLAN_TEAM, PLAN_TEAMPERSEAT, PLAN_TEAM3SEATS].includes(planId)
      ? planId
      : PLAN_TEAMPERSEAT2,
  ]

  const plans = availablePlans.map(
    (key) => planTypes[key as keyof typeof planTypes]
  )

  return (
    <div className={css.plansWrapper}>
      {plans.map((plan) => (
        <div
          key={plan.id}
          className={css.plan}
          style={{ borderTopColor: plan.color, color: plan.color }}
        >
          <h2 className={css.name}>
            {plan.name}
            {isTeamPlan(plan.id) && <Badge type="popular" />}
          </h2>
          <p className={cx(css.description, css.defaultText)}>
            {plan.description}
          </p>

          <div className={css.divider} />

          <h3 className={css.priceWrap}>
            <span className={css.price}>
              {plan.price[planType as keyof typeof plan.price]}
            </span>
            <span className={css.dollar}>$</span>
          </h3>

          <p className={cx(css.priceDescription, css.defaultText)}>
            {plan.paymentType[planType as keyof typeof plan.paymentType]}
          </p>

          <Button
            className={css.button}
            style={getButtonStyle(plan.color)}
            label={getButtonText(plan.id, planId)}
            loading={plan.id === loadingId}
            disabled={plan.id === planId}
            onClick={() =>
              onSubscribeClick(
                plan.id,
                plan.name,
                getVariant(plan.id, planId, loadingId, planIndex, types)
              )
            }
          />

          <Features features={plan.features} color={plan.color} />
          <Features features={plan.additional_features} color={plan.color} />
        </div>
      ))}
    </div>
  )
}
